import baseRoute from '../baseRoute';

export type * from './requestModel';
export type * from './viewModel';

type RouteDefinition = `${typeof baseRoute}/login/email/lms`;

export const ROUTE: RouteDefinition = `${baseRoute}/login/email/lms`;

export const URL = (): RouteDefinition => `${baseRoute}/login/email/lms`;
